{
  "app.title": "ColorGlo Kalender",
  "app.scaffold.heading": "Grunnstammen står",
  "app.scaffold.body": "Ansattes kalender, franchiseadmin og nettverksvisningen bygges i denne appen (P7–P10).",
  "health.label": "API",
  "health.checking": "Kontrollerer …",
  "health.ok": "Tilgjengelig",
  "health.unreachable": "Kan ikke nås",
  "nav.calendar": "Kalender",
  "nav.bookings": "Bestillinger",
  "nav.customers": "Kunder",
  "nav.reports": "Rapporter",
  "nav.settings": "Innstillinger",
  "nav.overview": "Oversikt",
  "nav.toggle_menu": "Vis eller skjul menyen",
  "nav.more": "Flere",
  "nav.breadcrumb": "Hvor du er",
  "nav.account": "Konto",
  "nav.impersonating": "Du jobber som {email}. Alt du gjør logges på begge kontoer.",
  "nav.close": "Lukk",
  "nav.language": "Språk",
  "language.sv": "Svenska",
  "language.no": "Norsk",
  "language.en": "English",
  "nav.theme": "Utseende",
  "theme.light": "Lyst",
  "theme.dark": "Mørkt",
  "form.required": "Obligatorisk",
  "language.da": "Dansk",
  "language.fi": "Suomi"
}
